import { AsyncAllegationModuleHandler } from "@/components/AsyncComponents";
export const withAllegationModuleWrapper = (WrappedComponent: any) => {
  return {
    template: `<AllegationModuleHandler><WrappedComponent></WrappedComponent></AllegationModuleHandler>`,
    components: {
      AllegationModuleHandler: AsyncAllegationModuleHandler,
      WrappedComponent,
    },
  };
};